import type { SxProps, Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { Stack } from 'components/ui';

export const authStatusPanelCompactTitleSx = {
  fontSize: 16,
  fontWeight: 400,
  lineHeight: 2,
  textAlign: 'center',
} satisfies SxProps<Theme>;

export const authStatusPanelCompactDescriptionSx = {
  color: 'text.primary',
  fontSize: 16,
  fontWeight: 400,
  lineHeight: 2,
  textAlign: 'center',
} satisfies SxProps<Theme>;

export const AuthStatusPanelRoot = styled(Stack)({
  alignItems: 'center',
  width: '100%',
});

export const AuthStatusPanelContentWrap = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(3),
  textAlign: 'center',
  width: '100%',
}));

export const AuthStatusPanelMainActionWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(5),
  width: '100%',
}));

export const AuthStatusPanelIconWrap = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: '999px',
  color: theme.palette.primary.main,
  display: 'inline-flex',
  height: 76,
  justifyContent: 'center',
  width: 76,
}));
